import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { validate_token } from '../../../api/authRequests';
import { useAuth } from '../../../context/AuthContext';


const AppRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();

  if (isLoading) {
    return <div></div>; // Or any other loading indicator.
  }

  return (
    <Route {...rest} render={props => (
      isAuthenticated ? (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={{
          pathname: '/login',
          state: { from: props.location },
        }} />
      )
    )} />
  );
};

export default AppRoute;